module.exports = __webpack_public_path__ + "img/behaviour-3.26dc7576.gif";